
import { defineComponent, ref, getCurrentInstance, onMounted } from 'vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { auth } from '@/services/auth'
import router from '@/router'
import { urlPath } from '@/utils'
import { basicStorage } from '@/services/storage'

const CognitoLoginForm = defineComponent({
  components: { ValidationObserver, ValidationProvider },
  props: {
    page: {
      type: String,
      required: true
    }
  },

  setup(props, { emit }) {
    const instance = getCurrentInstance()
    const { $refs, $root } = instance?.proxy

    const code = ref<string | null>('')
    const pass = ref<string | null>('')
    const inputPage = ref<string | null>('')
    const showPass = ref<boolean>(false)
    const loading = ref<boolean>(false)
    const errMsg = ref<string | null>(null)
    const bgImg = ref<string | null>(null)
    const passLabel = $root.$t('login.pass')
    const codeLabel = $root.$t('login.code')
    onMounted(() => {
      inputPage.value = props.page
    })
    const doLogin = async () => {
      const observer = $refs.observer as InstanceType<typeof ValidationObserver>
      const valid = await observer.validate()
      if (!valid) return
      loading.value = true
      const params = {
        code: code.value,
        pass: pass.value
      }
      const res = await auth.login(params)
      loading.value = false
      if (res.status) {
        errMsg.value = null
        const redirectUrl = basicStorage.popCallbackReferrer(urlPath.HOME.path)
        await router.push(redirectUrl)
      } else {
        errMsg.value = $root
          .$t('login.incorrect_username_or_password')
          .toString()
      }
    }

    return {
      pass,
      code,
      errMsg,
      showPass,
      loading,
      bgImg,
      codeLabel,
      passLabel,
      doLogin,
      inputPage
    }
  }
})

export default CognitoLoginForm
